import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import PrivacyPolicyModule from '@modules/PrivacyPolicy'

function PrivacyPolicyPage() {
  return <PrivacyPolicyModule />
}

/**
 *
 * @param {import('next').GetStaticPropsContext} ctx
 * @returns {import('next').GetStaticPropsResult}
 */
export async function getStaticProps(ctx) {
  return {
    props: { ...(await serverSideTranslations(ctx.locale, ['common'])) },
  }
}

PrivacyPolicyPage.getLayout = PrivacyPolicyModule.getLayout

export default PrivacyPolicyPage
